/* es5-ext/math/sign/is-implemented */ function _(require, module, exports) {
    module.exports = function () {
        var sign = Math.sign;
        if (typeof sign !== "function")
            return false;
        return (sign(10) === 1) && (sign(-20) === -1);
    };
}
